import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {MatDialog} from '@angular/material/dialog';
import {BehaviorSubject, Observable} from 'rxjs';
import {map} from 'rxjs/operators';

import {environment} from '../../../../environments/environment';
import {GetWaitingAreaListParamsInterface} from '../interfaces/waiting-area-params.interface';
import {getObjectUrlParams} from '../../../core/utils/filter-converter';
import {WaitingAreaInterface} from '../interfaces/waiting-area.interface';
import {ModalInfoComponent} from '../../../shared-modules/modals/modal-info/modal-info.component';
import {ApiConsultation, Consultation} from '../../consultations/interfaces/consultation.interface';
import {ApiResponse} from '../../../core/interfaces/response.interface';
import {prepareConsultation} from '../../../core/utils/prepare-entity/prepare-consultation';
import {JsonaService} from '../../../core/services/jsona.service';
import {DeserializedJsonInterface} from '../../../core/interfaces/jsona.interface';

@Injectable({providedIn: 'root'})

export class WaitingAreaService {
  onWaitingAreaUpdate$: BehaviorSubject<boolean | null> = new BehaviorSubject(null);
  currentQuickConsultationId$: BehaviorSubject<number> = new BehaviorSubject(null);
  newQuickConsultation$: BehaviorSubject<boolean | null> = new BehaviorSubject(null);

  private doctors4uaUrl = `${environment.doctors4uaUrl}/waiting-aria`;
  private doctors4uaUrlV2 = `${environment.doctors4uaUrlV2}/waiting-aria`;

  constructor(
    private http: HttpClient,
    private dialog: MatDialog,
    private jsonaService: JsonaService
  ) {
  }

  enterWaitingArea(): Observable<void> {
    return this.http.get<void>(`${this.doctors4uaUrl}/line-up`);
  }

  exitWaitingArea(): Observable<void> {
    return this.http.delete<void>(`${this.doctors4uaUrl}/exit`);
  }

  getWaitingAreaList(
    filter: Partial<GetWaitingAreaListParamsInterface>
  ): Observable<DeserializedJsonInterface<WaitingAreaInterface[]>> {
    const params = getObjectUrlParams(filter);
    return this.http.get(this.doctors4uaUrlV2, {params})
      .pipe(map((result) => (
        this.jsonaService.deserialize<WaitingAreaInterface[]>(result)
      )));
  }

  takePatient(waitingAreaId: number): Observable<Consultation> {
    return this.http
      .get<ApiResponse<ApiConsultation>>(`${this.doctors4uaUrl}/take-patient/${waitingAreaId}`)
      .pipe(
        map((result: ApiResponse<ApiConsultation>) => {
          return prepareConsultation(result.data);
        })
      );
  }

  onConsultationNotAvailable(): void {
    this.dialog.open(ModalInfoComponent, {
      data: {
        title: 'Заявка не актуальна',
        message: 'К сожалению, другой врач уже принял эту заявку',
        btnText: 'Ок'
      },
      panelClass: ['primary-modal'],
      autoFocus: false
    });
  }
}
